export const blogs = [
  {
    title:
      "Meet Motion: Your WhatsApp Assistant for Simplifying Everyday Services",
    description:
      "This article explains how Motion works, the serverless infrastructure behind it, and why WhatsApp-first conversational services are a smarter alternative for on-demand platforms.",
    image: "/images/motion.webp",
    link: "https://coderofph.hashnode.dev/why-motion-is-building-super-apps-on-whatsapp-not-mobile-apps",
  },
  {
    title: "Building Yard, an AI_Powered Real Estate Assistant on Whatsapp",
    description:
      "This article breaks down how Yard works, the infrastructure behind it, and why WhatsApp-first PropTech is a powerful alternative for housing startups.",
    image: "/images/yardimage.webp",
    link: "https://coderofph.hashnode.dev/building-yard-a-whatsapp-ai-real-estate-assistant-for-proptech",
  },
  {
    title: "Innovation Plan for Blinks AI, a Tech Startup",
    description:
      "This innovation plan outlines a set of strategic product initiatives designed to strengthen Blink AI’s value proposition, reduce onboarding friction, build user trust, and open new monetization paths.",
    image: "/images/blinksai.png",
    link: "https://coderofph.hashnode.dev/innovation-plan-for-blinks-ai",
  },
  {
    title: "Innovation Plan for Tracker, a Tech Startup",
    description:
      "This innovation plan proposes a set of user-driven, data-informed features designed to elevate Tracker into the next generation of social analytics tools.",
    image: "/images/tracker.webp",
    link: "https://coderofph.hashnode.dev/innovation-plan-for-tracker",
  },
  {
    title: "Eden Life Five-Year Innovation Plan",
    description:
      "This five-year innovation plan outlines strategic initiatives to enhance the food delivery experience that would set Eden Life apart in a competitive market.",
    image: "/images/eden.webp",
    link: "https://coderofph.hashnode.dev/eden-life-five-year-innovation-plan",
  },
];
